import { BrowserRouter, Route, Routes } from "react-router-dom";
import WcCrowd from "features/wc/routes/WcCrowd";

/**
 * ルート設定
 */
export default function RouterConfig() {
  return (
    <BrowserRouter basename="/web">
      <Routes>
        <Route index element={<WcCrowd />} />
        <Route path="/" element={<WcCrowd />} />
      </Routes>
    </BrowserRouter>
  );
}
